// extracted by mini-css-extract-plugin
export var addToCartButton = "_ns-b";
export var arrowButtonContainer = "_ns-9";
export var arrowButtonIcon = "_ns-a";
export var carouselArrowButton = "_ns-6";
export var carouselElementContainer = "_ns-1";
export var galleryThumbnail = "_ns-d";
export var galleryThumbnailImage = "_ns-e";
export var left = "_ns-7";
export var productDisplayCarouselContainer = "_ns-0";
export var productTileContainer = "_ns-2";
export var productTileImage = "_ns-4";
export var productTileImageContainer = "_ns-3";
export var productTileTitle = "_ns-5";
export var right = "_ns-8";
export var sliderOverflow = "_ns-c";